import React, {Fragment } from "react";
import { Button, TextLink } from "@vds/buttons";
import { Title, Body } from "@vds/typography";
import { Row, Col, Grid } from "@vds/grids";

export function InternetFiosService(props) {

    if(props?.addressQualificationDetails?.LQPost?.FiOSDataStatus ===
        "Y") {
return (
     <Grid
          className="OutofFranchise"
          style={{ marginLeft: "3px" }}
          colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}
          colGutter={false}
        >
        <Row className={`Page-Content ${props.bgForFirst} ${(props.isMobileOnly) ? 'mobile' : ''} ${(props.isTablet) ? 'tablet' : ''}`}>
          <Col
            className="Title-section"
            colSizes={{ mobile: 4, tablet: 9, desktop: 9 }}
          >
            <div className="Main-Title">
              <Title size="large" primitive="h2">
                Fios Business Internet
              </Title>
            </div>
            <div></div>
          </Col>

          <Col colSizes={{ mobile: 4, tablet: 5, desktop: 5 }} colGutter={true}>
            <Body className="verizon-ultra" size="large" primitive="h2">
            Verizon’s ultra-fast fiber-optic technology has 99.99% network reliability, so businesses can connect with ease.            </Body>
          </Col>
          <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
          <Col colSizes={{ mobile: 2, tablet: 2, desktop: 2 }} colGutter={true}>
            <Body size="large" primitive="h2" bold={true}>
              Prices start at:
            </Body>
            <Body size="large" primitive="h2">
              $69/mo*
            </Body>
          </Col>
          <Col colSizes={{ mobile: 2, tablet: 2, desktop: 2 }} colGutter={true}>
            <Body size="large" primitive="h2" bold={true}>
              Speeds start at:
            </Body>
            <Body size="large" primitive="h2">
            100 Mbps (upload/download)
            </Body>
          </Col>

          <Col
            colSizes={{ mobile: 4, tablet: 5, desktop: 5 }}
            colGutter={true}
          ></Col>
          <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
          <Col colSizes={{ mobile:4, tablet: 6, desktop: 6 }} colGutter={true}>
            <Body size="large" primitive="h2" bold={true}>
              Benefits:
            </Body>
            <Body size="large" primitive="h2">
              Speed, convenience, reliability.
            </Body>
          </Col>

          <Col
            colSizes={{ mobile: 6, tablet: 5, desktop: 5}}
            colGutter={true}
          ></Col>
          <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
          <Col
            colSizes={{ mobile: 4, tablet: 6, desktop:6 }}
            colGutter={true}
            className="topSpace"
          >
            <Body size="large" primitive="h2" bold={true}>
              Fios Business Internet is best for:
            </Body>
            <Body size="large" primitive="h2">
            Businesses with heavy data requirements that need to connect multiple devices with the speed and reliability of a 100% fiber network.
            </Body>
          </Col>
          { props.isMobileOnly ? (<Col
              className="Title-section"
              colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}
              className="topSpace"
            >
              <Body size="small" primitive="h2">
                {" "}
                *First-year price. Plus taxes, fees & equip. charges. Terms apply. Click BUY for details.

              </Body>
            </Col>) : (<Col
              className="Title-section">
            </Col>)}
          <Col
            className="Title-section"
            colSizes={{ mobile: 4, tablet: 5, desktop: 5 }}
          >
            <div className="Main-Title">
              <Button
                secondary
                size="large"
                onClick={() => props.fiosHsiRedirection()}
                className={`${props.bgForFirst ? "bgBtn" : "transperentButton"} ${props.isMobileOnly?'button-mobile':''}`}
              >
                Buy
              </Button>
            </div>
          </Col>
          <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
          { props.isMobileOnly ? (<Col
            className="Title-section">
            </Col>) : (<Col
              className="Title-section"
              colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}
              className="topSpace"
            >
              <Body size="small" primitive="h2">
                {" "}
                *First-year price. Plus taxes, fees & equip. charges. Terms apply. Click BUY for details.
              </Body>
            </Col>)}
            <Col
            className="Title-section"
            colSizes={{ mobile: 4, tablet: 5, desktop: 5 }}
            className="topSpace"
            > 
            </Col>
        </Row>
       </Grid>
)
    } else{
        return ""
    }

}
